module.exports = __webpack_public_path__ + "img/a0f8838.jpg";